import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { trpc } from '@/trpc';

export function useAuth() {
  const { user, tenant, setUser, setTenant, logout: clearStore } = useAuthStore();

  // Fetch user profile from the API on first load.
  // CF Access has already verified the user at the edge.
  const meQuery = (trpc as any).auth?.me?.useQuery?.(undefined, {
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !user,
  });

  // TanStack Query v5 removed onSuccess — sync data into the store via useEffect
  useEffect(() => {
    const data = meQuery?.data;
    if (data?.user) setUser(data.user);
    if (data?.tenant) setTenant(data.tenant);
  }, [meQuery?.data]);

  const isLoading = !user && (meQuery?.isLoading ?? false);
  const isAuthenticated = !!user;

  // Logout: clear local state and redirect to CF Access logout endpoint
  const logout = () => {
    clearStore();
    window.location.href = 'https://nanthiventures.cloudflareaccess.com/cdn-cgi/access/logout';
  };

  return { user, tenant, isLoading, isAuthenticated, logout };
}
